export default {
  CREATE_CUSTOMER_KUSPIT_ACCOUNT_COMMAND: Symbol.for('CREATE_CUSTOMER_KUSPIT_ACCOUNT_COMMAND'),
  CREATE_CUSTOMER_KUSPIT_ACCOUNT_REPOSITORY: Symbol.for('CREATE_CUSTOMER_KUSPIT_ACCOUNT_REPOSITORY'),
  CUSTOMER_KUSPIT_ACCOUNT_STATE_MANAGER: Symbol.for('CUSTOMER_KUSPIT_ACCOUNT_STATE_MANAGER'),
  CREATE_CUSTOMER_KUSPIT_ACCOUNT_STATUS_SUBSCRIPTION: Symbol.for('CREATE_CUSTOMER_KUSPIT_ACCOUNT_STATUS_SUBSCRIPTION'),
  CREATE_CUSTOMER_KUSPIT_CONTRACT_SUBSCRIPTION: Symbol.for('CREATE_CUSTOMER_KUSPIT_CONTRACT_SUBSCRIPTION'),
  OBTAIN_CUSTOMER_KUSPIT_ACCESS_TOKEN_SUBSCRIPTION: Symbol.for('OBTAIN_CUSTOMER_KUSPIT_ACCESS_TOKEN_SUBSCRIPTION'),
  GET_CREATE_CUSTOMER_KUSPIT_ACCOUNT_STATUS_QUERY: Symbol.for('GET_CREATE_CUSTOMER_KUSPIT_ACCOUNT_STATUS_QUERY'),
};
